import { ICardInfo, ICreditLineDetails } from "../models/CreditLineDetails";

export const getActivePhysicalCard = (
  summary: ICreditLineDetails | null
): ICardInfo | null => {
  const physicalCards = (summary?.cards ?? []).filter(
    (card) => card.type === "PHYSICAL"
  );

  if (physicalCards.length >= 1) {
    return physicalCards[physicalCards.length - 1];
  } else {
    return null;
  }
};
